import request from './request'

export function listBanners() {
  return request.get('/biz/cms/banners')
}
export function saveBanner(data) {
  return request.post('/biz/cms/banners', data)
}
export function deleteBanner(id) {
  return request.delete(`/biz/cms/banners/${id}`)
}

export function listContentTypes() {
  return request.get('/biz/cms/content-types')
}
export function saveContentType(data) {
  return request.post('/biz/cms/content-types', data)
}

export function listContents(params) {
  return request.get('/biz/cms/contents', { params })
}
export function saveContent(data) {
  return request.post('/biz/cms/contents', data)
}

export function listCmsCases() {
  return request.get('/biz/cms/cases')
}
export function saveCmsCase(data) {
  return request.post('/biz/cms/cases', data)
}
export function deleteCmsCase(id) {
  return request.delete(`/biz/cms/cases/${id}`)
}

export function listCaseCategories() {
  return request.get('/biz/cms/case-categories')
}
export function saveCaseCategory(data) {
  return request.post('/biz/cms/case-categories', data)
}

export function listTagGroups() {
  return request.get('/biz/cms/tag-groups')
}
export function saveTagGroup(data) {
  return request.post('/biz/cms/tag-groups', data)
}
export function deleteTagGroup(id) {
  return request.delete(`/biz/cms/tag-groups/${id}`)
}

export function listTags(params) {
  return request.get('/biz/cms/tags', { params })
}
export function saveTag(data) {
  return request.post('/biz/cms/tags', data)
}
export function deleteTag(id) {
  return request.delete(`/biz/cms/tags/${id}`)
}

export function listInvites() {
  return request.get('/biz/cms/invites')
}
export function createInvite(data) {
  return request.post('/biz/cms/invites', data)
}
export function inviteQrcode(id) {
  return request.get(`/biz/cms/invites/${id}/qrcode`)
}
export function deleteInvite(id) {
  return request.delete(`/biz/cms/invites/${id}`)
}

export function listSignups(params) {
  return request.get('/biz/cms/signups', { params })
}
export function deleteSignup(id) {
  return request.delete(`/biz/cms/signups/${id}`)
}
